jQuery(document).ready(function () {
  let animationFrame;

  jQuery("a.mad-button-glow, button.mad-button-glow, .mad-navbar__nav-item--button > a").each(function() {
    jQuery(this).on("mouseenter", function () {
      const button = jQuery(this);

      function handleMouseMove(e) {
        if (animationFrame) {
          cancelAnimationFrame(animationFrame);
        }
    
        animationFrame = requestAnimationFrame(() => {
          const offset = button.offset();
          const width = button.outerWidth();
          const glowSize = width * 0.6;
          const halfGlow = glowSize / 2;
    
          let percent = ((e.pageX - offset.left) / width) * 100;
    
          // Constrain values to prevent overflow
          percent = Math.max((halfGlow / width) * 100, Math.min(100 - (halfGlow / width) * 100, percent));
    
          button.css("--glow-left", percent + "%");
        });
      }

      // Attach the optimized mousemove event
      button.on("mousemove", handleMouseMove);

      // Remove event on mouse leave to free up resources
      button.on("mouseleave", function () {
        button.off("mousemove", handleMouseMove);
      });
    });
  })
});
